import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface SentryErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

export function SentryErrorFallback({ error, resetError }: SentryErrorFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-8 w-8 text-destructive mr-3 shrink-0" />
            <h1 className="text-xl font-semibold text-foreground">
              Something went wrong
            </h1>
          </div>
          
          <p className="text-muted-foreground mb-4">
            An unexpected error occurred. Our team has been notified.
          </p>
          
          {import.meta.env.DEV && (
            <details className="mb-4">
              <summary className="cursor-pointer text-sm text-muted-foreground hover:text-foreground transition-colors">
                Error details (development only)
              </summary>
              <pre className="mt-2 text-xs bg-muted p-2 rounded overflow-auto text-muted-foreground">
                {error.message}
                {error.stack}
              </pre>
            </details>
          )}
          
          <div className="flex gap-3">
            <Button
              onClick={resetError}
              variant="default"
              className="flex-1"
            >
              Try again
            </Button>
            <Button
              onClick={() => window.location.href = '/'}
              variant="outline"
              className="flex-1"
            >
              Go home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
